(function () {
  function initImageCompare(root) {
    if (!root) return;
    root.querySelectorAll('.container-media').forEach(function (container) {
      var slider = container.querySelector('.slider');
      if (!slider) return;
      slider.addEventListener('input', function (e) {
        container.style.setProperty('--position', e.target.value + '%');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initImageCompare(document);
    });
  } else {
    initImageCompare(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initImageCompare(event.target);
  });
})();
